// Disclaimer page translations
const disclaimerTranslations = {
  en: {
    hero: {
      pill: "Disclaimer",
      title: "Information",
      subtitle: "Legal information and contact details."
    },
    sections: {
      title: "Information",
      company: {
        name: "thewhizkind",
        person: "Prayrit Singh"
      },
      contact: {
        label: "Contact",
        items: [
          { label: "E-Mail", value: "prayrit@thewhizkind.com", type: "email" },
          { label: "Website", value: "www.thewhizkind.com", type: "url" },
          { label: "Business address (Germany)", value: "Gumbertstraße 150 EG Rechts, 40229 Düsseldorf" },
          { label: "Business address (India)", value: "20, Block H-1/A, Sector 63, Noida 201301, Uttar Pradesh, India" }
        ]
      },
      vat: {
        label: "VAT Identification Number in accordance with §27a of the German VAT Act",
        value: "018 870 02282"
      },
      gst: {
        label: "GST Identification Number (India)",
        value: "GSTIN: 09LBAPS6420C1ZM"
      },
      accessibility: {
        label: "Accessibility",
        content: [
          "We aim to make thewhizkind accessible to as many people as possible and use the <strong>Web Content Accessibility Guidelines (WCAG) 2.2 Level AA</strong> as our accessibility target.",
          "Accessibility is continuously reviewed and improved as the website develops. Despite our efforts, individual barriers may remain.",
          "For more information about accessibility, available preferences or to report a barrier, please visit our <link-accessibility>accessibility page</link-accessibility> or contact us at <email>prayrit@thewhizkind.com</email>."
        ]
      },
      responsible: {
        label: "Responsible for content",
        value: "Prayrit Singh"
      }
    }
  },
  de: {
    hero: {
      pill: "Impressum",
      title: "Angaben & Information",
      subtitle: "Rechtliche Hinweise und Kontaktinformationen."
    },
    sections: {
      title: "Angaben",
      company: {
        name: "thewhizkind",
        person: "Prayrit Singh"
      },
      contact: {
        label: "Kontakt",
        items: [
          { label: "E-Mail", value: "prayrit@thewhizkind.com", type: "email" },
          { label: "Website", value: "www.thewhizkind.com", type: "url" },
          { label: "Geschäftsanschrift (Deutschland)", value: "Gumbertstraße 150 EG Rechts, 40229 Düsseldorf" },
          { label: "Geschäftsanschrift (Indien)", value: "20, Block H-1/A, Sector 63, Noida 201301, Uttar Pradesh, India" }
        ]
      },
      vat: {
        label: "Umsatzsteuer-Identifikationsnummer gemäß §27a UStG",
        value: "018 870 02282"
      },
      gst: {
        label: "GST-Identifikationsnummer (Indien)",
        value: "GSTIN: 09LBAPS6420C1ZM"
      },
      accessibility: {
        label: "Barrierefreiheit",
        content: [
          "Wir möchten thewhizkind für möglichst viele Menschen zugänglich machen und orientieren uns dabei an den <strong>Web Content Accessibility Guidelines (WCAG) 2.2, Konformitätsstufe AA</strong>.",
          "Die Barrierefreiheit wird während der Weiterentwicklung der Website fortlaufend überprüft und verbessert. Trotz unserer Bemühungen können einzelne Barrieren bestehen bleiben.",
          "Weitere Informationen zur Barrierefreiheit und zu den verfügbaren Einstellungen sowie die Möglichkeit, eine Barriere zu melden, findest du auf unserer <link-accessibility>Seite zur Barrierefreiheit</link-accessibility> oder kontaktiere uns unter <email>prayrit@thewhizkind.com</email>."
        ]
      },
      responsible: {
        label: "Verantwortlich für den Inhalt",
        value: "Prayrit Singh"
      }
    }
  }
};

export default disclaimerTranslations;